import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function BankIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      viewBox="0 0 69.99 69.99"
      {...props}
    >
      <line
        x1="1.62"
        y1="68.36"
        x2="68.36"
        y2="68.36"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="m68.36,20.69H1.62L32.42,2.38c1.57-1.01,3.58-1.01,5.15,0l30.79,18.31Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <polyline
        points="63.59 30.23 63.59 58.83 54.06 58.83 54.06 30.23"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <polyline
        points="39.76 30.23 39.76 58.83 30.23 58.83 30.23 30.23"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <polyline
        points="15.93 30.23 15.93 58.83 6.39 58.83 6.39 30.23"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
